var Map = function Map(selector, options) {
	var $ = require('jquery');
	var hasTouch = require('has-touch');
	var GoogleMapsLoader = require('google-maps');
	var $map = $('[data-map="true"].' + selector);
	if(!$map.length) return;
	if(typeof options === 'undefined') options = {};

	GoogleMapsLoader.KEY = window.__CONFIG__.google_api_key;
	GoogleMapsLoader.load(function(google) {
		var cords = new google.maps.LatLng(parseFloat($map.attr('data-lat')), parseFloat($map.attr('data-lng')));

		var mapOptions = $.extend({
			center: cords,
			zoom: 13,
			disableDefaultUI: true
		}, options)
		if(hasTouch) mapOptions.draggable = false, mapOptions.scrollwheel = false;

		var map = new google.maps.Map($map[0], mapOptions);
		var gmark = new google.maps.Marker({
			position: cords,
			map: map,
			title: 'Communication Unlimited'
		});

		//map.event.trigger(map, "resize");
	});
}

module.exports = Map;
